import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/user-button/user-button.js';
      import {Variant, Size, StyleType} from '@oicl/openbridge-webcomponents/dist/components/user-button/user-button.js';

      export interface Props {
     variant?: Variant;
     size?: Size;
     styleType?: StyleType;
     static?: boolean;
     disabled?: boolean;
     initials?: string;
     label?: string | undefined
   }

      
  
      export type {Variant, Size, StyleType} from '@oicl/openbridge-webcomponents/dist/components/user-button/user-button.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcUserButton',
  props: {
    variant: {},
    size: {},
    styleType: {},
    static: { type: Boolean },
    disabled: { type: Boolean },
    initials: {},
    label: {}
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-user-button',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})